import DirectDepositBenefits from 'features/onboarding/screens/DirectDepositBenefits/DirectDepositBenefits';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function Page() {
  return (
    <PinwheelContextProvider>
      <DirectDepositBenefits />
    </PinwheelContextProvider>
  );
}
